import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormSelectModelDto } from "../../../payment-link-list/models/paylinks.model";
import { NgxFileDropEntry } from "ngx-file-drop";
import { SupportDataService } from "../../services/support-data.service";
import { ModalService } from "../../../../services/modal.service";
import { CreateContactingDto } from "../../models/support.models";
import { FilesToStringService } from "../../../../services/files-to-string.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "app-add-contacting-dialog",
  templateUrl: "./add-contacting-dialog.component.html",
  styleUrls: ["./add-contacting-dialog.component.scss"],
})
export class AddContactingDialogComponent implements OnInit {
  @Input() supportTypeList: FormSelectModelDto[] = [];

  @Output() createdConnectingEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() fileNotLoadedEvent: EventEmitter<void> = new EventEmitter<void>();

  form!: FormGroup;

  commentText = "";

  files: NgxFileDropEntry[] = [];

  isSending = false;

  subs: Subscription[] = [];

  constructor(
    private modalService: ModalService,
    private filesToStringService: FilesToStringService,
    private supportDataService: SupportDataService
  ) {}

  ngOnInit() {
    this.formInit();
    this.subscribeInit();
  }

  subscribeInit() {
    this.subs.push(
      this.modalService.isModalOpen$.subscribe({
        next: (res) => {
          if (!res) {
            this.clearForm();
          }
        },
      })
    );
  }

  formInit() {
    this.form = new FormGroup({
      commentFormControl: new FormControl("", [Validators.required]),
      typeFormControl: new FormControl("", [Validators.required]),
    });
  }

  get commentRequiredError() {
    return this.form.get("commentFormControl")?.hasError("required");
  }

  get typeRequiredError(): string {
    if (this.form.get("typeFormControl")?.hasError("required") && this.form.get("typeFormControl")?.touched) {
      return "SUPPORT_PAGE.MODAL.ERROR.TYPE_REQUIRED";
    } else {
      return "";
    }
  }

  close() {
    this.clearForm();
    this.modalService.closeModal();
  }

  clearForm() {
    this.form.reset();
    this.files = [];
  }

  dropped(files: NgxFileDropEntry[]) {
    const filesType = ["jpg", "jpeg", "bmp", "gif", "png", "doc", "docx", "pdf", "xlsx", "xls", "rar", "zip"];
    for (const droppedFile of files) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        const type = file.name.substring(file.name.lastIndexOf(".") + 1);
        if (filesType.includes(type) && file.size / 1048576 <= 1 && this.files.length <= 4) {
          this.files.push(droppedFile);
        } else {
          this.fileNotLoadedEvent.emit();
        }
      });
    }
  }

  fileOver(event: any) {
    // console.log(event);
  }

  fileLeave(event: any) {
    // console.log(event);
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  sendSupport() {
    this.isSending = true;
    this.filesToStringService.toFilesBase64(this.files).subscribe({
      next: (res) => {
        const data: CreateContactingDto = {
          text: this.form.controls["commentFormControl"].value,
          support_type: this.form.controls["typeFormControl"].value,
          userId: localStorage.getItem("user_id") ?? "",
          is_for_admin: false,
          files: res,
        };

        this.supportDataService.createContacting(data).subscribe({
          next: () => {
            this.close();
            this.createdConnectingEvent.emit();
            this.isSending = false;
          },
          error: () => {
            this.files = [];
            this.form.reset();
            this.isSending = false;
          },
        });
      },
    });
  }
}
